import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'react/components/Modal/Modal';

import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/modals';

function WglnLogDetailsModal() {
  const dispatch = useDispatch();

  const modalKey = useMemo(() => 'wglnLogDetails', []);
  const isOpen = useSelector((state) => state.modals.getIn([modalKey, 'isOpen']));
  const title = useSelector((state) => state.modals.getIn([modalKey, 'title']));

  const {
    routeKey,
    routeDate,
    requestDate,
    status,
    message,
    actionPerformed,
    organizationKey
  } = useSelector((state) => state.modals.getIn([modalKey, 'data']).toJS());

  const formatMessage = useCallback((jsonText) => {
    try {
      const messageParsed = JSON.parse(jsonText);

      return JSON.stringify(messageParsed, null, 2).replace(/"/g, '');
    } catch (error) {
      return jsonText;
    }
  }, []);

  const closeModal = useCallback(() => {
    dispatch(actionCreators.closeModal({
      modalKey
    }));
  }, []);

  const ModalFooter = (
    <div className="footerModal">
      <button
        data-testid="close-logdetails-modal"
        type="button"
        className="btn-secondary"
        onClick={closeModal}
      >
        {getResourceTo('default.button.close')}
      </button>
    </div>
  );

  function getContainer() {
    let container = document
      .querySelector('.mainContainer .reactivo-tabs.gmTabs #logsDetailsModalWrapper');

    if (!container) {
      container = document.createElement('div');
      container.id = 'logsDetailsModalWrapper';

      document.querySelector('.mainContainer .reactivo-tabs.gmTabs').appendChild(container);
    }

    return container;
  }

  return (
    <Modal
      className="logDetailsModal"
      isOpen={isOpen}
      title={getResourceTo(title)}
      crossAxisBtn={false}
      footer={ModalFooter}
      closeModalFn={closeModal}
      parentSelector={() => getContainer()}
    >
      <div className="modalBody" data-testid="modal-logdetails-body">
        <div className="row">
          <div className="leftLogContent">
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.routeKey')}</p>
              <span data-testid="logdetails-routeKey">{routeKey}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.organization')}</p>
              <span data-testid="logdetails-organization">{organizationKey}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.routeDate')}</p>
              <span data-testid="logdetails-date">{routeDate}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.actionPerformed')}</p>
              <span data-testid="logdetails-action-performed">{actionPerformed}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.actionTime')}</p>
              <span data-testid="logdetails-requestDate">{requestDate}</span>
            </div>
            <div className="sectionDetail status">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.status')}</p>
              {status === 200 && (
                <div data-testid="logdetails-icon-success" className="statusSuccess">
                  <span className="icon" />
                  <span className="text">{getResourceTo('IntegrationLogModal.SuccessText')}</span>
                </div>
              )}
              {status !== 200 && (
                <div data-testid="logdetails-icon-error" className="statusError">
                  <span className="icon" />
                  <span className="text">{getResourceTo('IntegrationLogModal.ErrorText')}</span>
                </div>
              )}
            </div>
          </div>
          <div className="rightLogContent">
            <div className="sectionDetail requestBody">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.message')}</p>
              <span className="preRequest">
                <pre>{formatMessage(message)}</pre>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default memo(WglnLogDetailsModal);
